<template>
<div class="home page-template-default">
  <HeadNav :selectedLanguage="selectedLanguage" page="gb" :gotodownload="gotodownload" :apk="apk"/>

  <main class="site-main">

    <section class="hero" aria-labelledby="hero-title">
      <div class="hero-bg" aria-hidden="true">
        <div class="hero-orb hero-orb--1"></div>
        <div class="hero-orb hero-orb--2"></div>
        <div class="hero-orb hero-orb--3"></div>
        <div class="hero-grid"></div>
      </div>

      <BreadcrumbNav variant="hero" style="margin-bottom: 12px;" />

      <div class="hero-inner">
        <div class="hero-content">
          <!-- 文档布局：标题 → 图标 → 描述 → 下载按钮 → 修复链接 → 信息卡 -->
          <h1 id="hero-title" class="hero-title">GB WhatsApp APK Download v18.80 Latest Version 2026</h1>

          <div class="hero-logo-wrap">
            <img class="hero-logo" src="@/assets/logo.webp" alt="GB WhatsApp" width="112" height="112" loading="eager" onerror="this.style.display='none'" />
          </div>

          <p class="hero-desc">Download GB WhatsApp APK v18.80 with advanced privacy features, custom themes, and enhanced messaging tools for Android.</p>

          <div class="hero-actions">
            <a href="/download/" class="btn-download-hero" @click="downloadClick">Download APK</a>
            <a href="/app-not-installed-error/" class="btn-learn-hero">Not Installing? Check the Fix ✅</a>
          </div>

          <div class="hero-facts" aria-label="GB WhatsApp version facts">
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M4 6h12v2H4V6zm0 5h16v2H4v-2zm0 5h10v2H4v-2z"/><path fill="currentColor" d="M18 4h2v16h-2z" opacity=".45"/></svg>
              <p class="hero-fact-text"><span>Version</span> <strong>18.80</strong></p>
            </div>
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M6 2h9l5 5v15a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm8 1.5V8h4.5L14 3.5z"/></svg>
              <p class="hero-fact-text"><span>Size</span> <strong>95.0 MB</strong></p>
            </div>
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-4.42 0-8 2.24-8 5v1h16v-1c0-2.76-3.58-5-8-5z"/></svg>
              <p class="hero-fact-text"><span>Founder</span> <strong>GBWhetsapp</strong></p>
            </div>
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>
              <p class="hero-fact-text"><span>Downloads</span> <strong>10M+</strong></p>
            </div>
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M17.6 9.48l1.37-1.37a1 1 0 10-1.41-1.41l-1.52 1.52A7.96 7.96 0 0012 7a8 8 0 00-8 8v1h16v-1a7.96 7.96 0 00-2.4-5.52zM7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/></svg>
              <p class="hero-fact-text"><span>Android</span> <strong>5.0+</strong></p>
            </div>
            <div class="hero-fact">
              <svg class="hero-fact-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
              <p class="hero-fact-text"><span>Rating</span> <strong>4.7</strong></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-whatis">
      <div class="section-inner">
        <p class="section-tag">Overview</p>
        <!-- 文档顺序：从 At GBWhatsApp.com 开篇 → 目标 → 免责 → What is 定义 -->
        <div class="section-body">
          <p>At <strong><a href="/" class="inline-link">GBWhatsApp.com</a></strong>, we personally tested the latest <strong>GB WhatsApp v18.80</strong> on a real Android device to evaluate its installation process, performance, features, and potential security risks. Our hands-on testing gives users a clearer understanding of how the app works before installing it.</p>
          <p>Our goal is to provide accurate, practical, and unbiased information so visitors can make informed decisions when downloading and using GB WhatsApp.</p>
          <p>Readers comparing independent resources can also review <a href="https://androidwaves.org/gb-whatsapp-apk/" class="inline-link" target="_blank" rel="noopener">GB WhatsApp APK</a> coverage and the <a href="https://gbwhataps.com/" class="inline-link" target="_blank" rel="noopener">GBWhatsApp</a> homepage before choosing a build.</p>
          <p>GB WhatsApp is a third-party app and is not affiliated with or endorsed by WhatsApp or Meta. Please use it at your own discretion.</p>
        </div>

        <h2 id="sec-whatis" class="section-title">What is GB WhatsApp?</h2>
        <div class="section-body">
          <p><strong><a href="/" class="inline-link">GB WhatsApp</a></strong> is a modified version of WhatsApp that adds extra customization and privacy options beyond the standard WhatsApp application. It is designed for users who want more control over their chats, appearance, and messaging experience.</p>
          <p>Unlike the official WhatsApp app, GBWhatsApp includes additional tools such as hiding online status, changing themes, scheduling messages, downloading statuses, and customizing the interface.</p>
          <p>GB WhatsApp works on most Android devices and is commonly used by people who want more flexibility when managing their WhatsApp conversations.</p>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-download">
      <div class="section-inner">
        <p class="section-tag">Latest APK</p>
        <h2 id="sec-download" class="section-title">Download GB WhatsApp APK Latest Version</h2>
        <div class="section-body">
          <p>The latest <strong><a href="/download/" class="inline-link">GB WhatsApp APK</a></strong> includes improvements in stability, performance, and compatibility with newer Android versions. The updated version focuses on smoother messaging, better privacy controls, and additional customization options.</p>
          <p>Before installing GB WhatsApp, make sure your device has enough storage space and that you have created a backup of your WhatsApp chats.</p>
        </div>
        <div class="download-info-grid">
          <div class="download-info-card download-info-card--padded">
            <h3 class="card-title">Latest Version Details</h3>
            <div class="compare-table-wrap detail-table-wrap">
              <table class="compare-table detail-table" aria-label="Latest GB WhatsApp version details">
                <thead><tr><th>Feature</th><th>Information</th></tr></thead>
                <tbody>
                  <tr><td>Version</td><td>GB WhatsApp v18.80</td></tr>
                  <tr><td>Size</td><td>95 MB</td></tr>
                  <tr><td>Supported Android</td><td>Android 5.0 and above</td></tr>
                  <tr><td>Update Status</td><td>Stable Version</td></tr>
                  <tr><td>Category</td><td>Communication App</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <h3 class="subsection-title subsection-title--dark">How to Download and Install GB WhatsApp on Android</h3>
        <ol class="install-timeline" aria-label="GB WhatsApp install steps">
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Download the latest GB WhatsApp APK.</strong></div>
          </li>
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Enable "Install Unknown Apps"</strong> in your Android settings.</div>
          </li>
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Open the downloaded APK</strong> and tap <strong>Install.</strong></div>
          </li>
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Launch GB WhatsApp</strong> after installation.</div>
          </li>
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Verify your phone number</strong> and restore your backup (optional).</div>
          </li>
          <li class="install-timeline-item">
            <span class="install-timeline-dot" aria-hidden="true"></span>
            <div class="install-timeline-body"><strong>Start using GB WhatsApp.</strong></div>
          </li>
        </ol>
        <p class="install-note"><strong>Note:</strong> Make sure you back up your chats before switching from the official WhatsApp app.</p>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-requirements">
      <div class="section-inner">
        <p class="section-tag">Compatibility</p>
        <h2 id="sec-requirements" class="section-title">GBWhatsApp System Requirements</h2>
        <div class="section-body">
          <p>Before downloading GB WhatsApp APK, make sure your Android device meets the basic requirements for smooth installation and stable performance.</p>
        </div>
        <h3 class="subsection-title subsection-title--dark">Minimum requirements for GB WhatsApp:</h3>
        <ul class="req-list">
          <li><strong>Application:</strong> GB WhatsApp APK</li>
          <li><strong>Version:</strong> v18.80</li>
          <li><strong>Android Version:</strong> Android 5.0 or higher</li>
          <li><strong>Storage Space:</strong> At least 100 MB free storage</li>
          <li><strong>Internet:</strong> Required for number verification and messaging features</li>
          <li><strong>Installation Type:</strong> Manual APK installation</li>
        </ul>
        <div class="section-body">
          <p>If your device meets these requirements, you should be able to install and use GB WhatsApp without major issues. For better performance, keep your Android system and the app updated to the latest version.</p>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-features">
      <div class="section-inner">
        <p class="section-tag">Capabilities</p>
        <h2 id="sec-features" class="section-title">GB WhatsApp Features</h2>
        <div class="section-body">
          <p>GB WhatsApp includes a variety of <a href="/features/" class="inline-link">extra features</a> designed to improve the messaging experience.</p>
        </div>

        <h3 class="subsection-title subsection-title--dark">Privacy Features</h3>
        <div class="section-body">
          <p>Privacy is one of the main reasons users install GBWhatsApp. The app provides additional controls to manage online visibility and message activity.</p>
          <p>Popular privacy options include:</p>
        </div>
        <ul class="req-list">
          <li>Hide online status</li>
          <li><a href="/hide-blue-ticks/" class="inline-link">Hide blue ticks</a></li>
          <li>Hide typing status</li>
          <li>Hide recording status</li>
          <li>View deleted messages</li>
        </ul>

        <h3 class="subsection-title subsection-title--dark">Custom Themes and Interface</h3>
        <div class="section-body">
          <p>GB WhatsApp gives users more control over the appearance of the application.</p>
          <p>Users can change:</p>
        </div>
        <ul class="req-list">
          <li>App themes</li>
          <li>Chat backgrounds</li>
          <li>Fonts</li>
          <li>Colors</li>
          <li>Notification styles</li>
        </ul>

        <h3 class="subsection-title subsection-title--dark">Media Sharing Improvements</h3>
        <div class="section-body">
          <p>Compared with the standard WhatsApp experience, GB WhatsApp offers enhanced media options.</p>
          <p>Users can:</p>
        </div>
        <ul class="req-list">
          <li>Share larger files</li>
          <li>Send more images at once</li>
          <li>Download WhatsApp statuses</li>
          <li>Customize media settings</li>
        </ul>

        <h3 class="subsection-title subsection-title--dark">Automation Tools</h3>
        <div class="section-body">
          <p>GBWhatsApp includes several features that help manage conversations more efficiently.</p>
          <p>Examples:</p>
        </div>
        <ul class="req-list">
          <li><a href="/auto-reply/" class="inline-link">Auto reply</a></li>
          <li><a href="/message-scheduler/" class="inline-link">Scheduled messages</a></li>
          <li>Quick replies</li>
          <li><a href="/dnd-mode/" class="inline-link">DND mode</a></li>
        </ul>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-updates">
      <div class="section-inner">
        <p class="section-tag">v18.80 Update</p>
        <h2 id="sec-updates" class="section-title">GB WhatsApp v18.80 New Updates</h2>
        <div class="section-body">
          <p>The newest GBWhatsApp v18.80 focuses on improving reliability and user experience.</p>
          <p>The latest version includes:</p>
        </div>
        <ul class="req-list">
          <li>Better Android compatibility</li>
          <li>Improved app stability</li>
          <li>Updated privacy settings</li>
          <li>Faster performance</li>
          <li>Bug fixes and improvements</li>
        </ul>
        <div class="section-body">
          <p>Users who are running older versions may benefit from updating to the latest release to maintain compatibility with newer Android devices.</p>
        </div>

        <h3 class="subsection-title subsection-title--dark">How to Update GB WhatsApp Without Losing Chats</h3>
        <ol class="update-guide" aria-label="Update GB WhatsApp without losing chats">
          <li class="update-guide-card">
            <div class="update-guide-head">
              <span class="update-guide-num" aria-hidden="true"></span>
              <div class="update-guide-meta">
                <span class="update-guide-label">Step 1</span>
                <strong class="update-guide-title">Back up your chats</strong>
              </div>
            </div>
            <ul class="update-guide-list">
              <li>Open <strong>GB WhatsApp</strong>.</li>
              <li>Go to <strong>Settings → Chats → Chat Backup</strong>.</li>
              <li>Tap <strong>Back Up</strong> to create a local backup. This helps protect your messages if something goes wrong.</li>
            </ul>
          </li>
          <li class="update-guide-card">
            <div class="update-guide-head">
              <span class="update-guide-num" aria-hidden="true"></span>
              <div class="update-guide-meta">
                <span class="update-guide-label">Step 2</span>
                <strong class="update-guide-title">Download the latest GBWhatsApp APK</strong>
              </div>
            </div>
            <ul class="update-guide-list">
              <li>Get the newest version from a source you trust.</li>
              <li>Avoid downloading APKs from unknown or suspicious websites.</li>
            </ul>
          </li>
          <li class="update-guide-card">
            <div class="update-guide-head">
              <span class="update-guide-num" aria-hidden="true"></span>
              <div class="update-guide-meta">
                <span class="update-guide-label">Step 3</span>
                <strong class="update-guide-title">Install the APK</strong>
              </div>
            </div>
            <ul class="update-guide-list">
              <li>Open the downloaded APK file.</li>
              <li>If prompted, enable <strong>Install unknown apps</strong> for your browser or file manager.</li>
              <li>Tap <strong>Install</strong>.</li>
              <li class="update-guide-warn"><strong>Do not uninstall your current GB WhatsApp first</strong>, or you may lose your local data. Installing over the existing app usually preserves your chats and settings.</li>
            </ul>
          </li>
          <li class="update-guide-card">
            <div class="update-guide-head">
              <span class="update-guide-num" aria-hidden="true"></span>
              <div class="update-guide-meta">
                <span class="update-guide-label">Step 4</span>
                <strong class="update-guide-title">Open GB WhatsApp</strong>
              </div>
            </div>
            <ul class="update-guide-list">
              <li>Launch the updated app.</li>
              <li>Confirm that your chats, media, and settings are still available.</li>
              <li>If prompted, restore the backup you created earlier.</li>
            </ul>
          </li>
        </ol>

        <h3 class="subsection-title subsection-title--dark">If the Update Fails</h3>
        <div class="fail-panel">
          <div class="fail-panel-head">
            <span class="fail-panel-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
            </span>
            <p class="fail-panel-lead">Try these fixes:</p>
          </div>
          <ul class="fail-panel-list">
            <li>Ensure you downloaded the correct APK version for your device.</li>
            <li>Make sure you have enough free storage.</li>
            <li>Restart your phone and try again.</li>
            <li>If the app crashes after updating, go to <strong>Settings → Apps → GB WhatsApp → Storage → Clear Cache</strong> (avoid clearing data unless you're prepared to restore from backup).</li>
          </ul>
        </div>

        <h3 class="subsection-title subsection-title--dark">How to Back Up GBWhatsApp Chats</h3>
        <ol class="doc-steps doc-steps--simple">
          <li>Open <strong>GBWhatsApp</strong> on your Android device.</li>
          <li>Tap the <strong>three-dot menu</strong> in the top-right corner.</li>
          <li>Go to <strong>Settings → Chats → Chat Backup</strong>.</li>
          <li>Tap <strong>Backup</strong> to create a local backup of your chats and media.</li>
          <li>Wait until the backup process is complete.</li>
        </ol>
        <div class="section-body">
          <p>Your messages, photos, and videos will be saved on your device storage.</p>
        </div>

        <h3 class="subsection-title subsection-title--dark">Where Is the GB WhatsApp Backup Stored?</h3>
        <div class="section-body">
          <p>GB WhatsApp backup files are usually stored in the <strong>GBWhatsApp</strong> folder.</p>
          <p>You can find them here:</p>
          <p><strong>File Manager → Internal Storage → GBWhatsApp → Databases</strong></p>
          <p>Keep this folder safe if you want to restore your chats later.</p>
        </div>

        <h3 class="subsection-title subsection-title--dark">How to Restore GB WhatsApp Chats</h3>
        <ol class="doc-steps doc-steps--simple">
          <li>Install the latest GB WhatsApp APK on your Android device.</li>
          <li>Open the app and verify your phone number.</li>
          <li>GBWhatsApp will automatically detect available backup files.</li>
          <li>Tap <strong>Restore</strong> and wait for the process to finish.</li>
          <li>Your chats and media will appear after the restore is completed.</li>
        </ol>

        <h3 class="subsection-title subsection-title--dark">Tips for Safer Backups</h3>
        <ul class="req-list">
          <li>Create backups regularly to avoid losing important chats.</li>
          <li>Save a copy of the <strong>GBWhatsApp folder</strong> before reinstalling or updating.</li>
          <li>Always download updates from trusted sources to reduce installation and data loss risks.</li>
        </ul>
        <div class="section-body">
          <p>Following these steps helps you keep your GBWhatsApp chats and media safe and restore them whenever needed.</p>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-compare">
      <div class="section-inner">
        <p class="section-tag">Comparison</p>
        <h2 id="sec-compare" class="section-title">GB WhatsApp vs Official WhatsApp</h2>
        <div class="section-body">
          <p>GB WhatsApp and the official WhatsApp app offer similar messaging functions, but they provide different experiences.</p>
        </div>
        <div class="compare-table-wrap">
          <table class="compare-table" aria-label="GB WhatsApp vs Official WhatsApp comparison">
            <thead>
              <tr><th>Feature</th><th>GB WhatsApp</th><th>Official WhatsApp</th></tr>
            </thead>
            <tbody>
              <tr><td>Send Messages</td><td class="cell-highlight">Yes</td><td class="cell-highlight">Yes</td></tr>
              <tr><td>Voice &amp; Video Calls</td><td class="cell-highlight">Yes</td><td class="cell-highlight">Yes</td></tr>
              <tr><td>Custom Themes</td><td class="cell-highlight">Yes</td><td class="cell-muted">Limited</td></tr>
              <tr><td>Hide Online Status</td><td class="cell-highlight">Yes</td><td class="cell-muted">Limited</td></tr>
              <tr><td>Auto Reply</td><td class="cell-highlight">Yes</td><td class="cell-muted">No</td></tr>
              <tr><td>Message Scheduler</td><td class="cell-highlight">Yes</td><td class="cell-muted">No</td></tr>
              <tr><td>Status Downloader</td><td class="cell-highlight">Yes</td><td class="cell-muted">No</td></tr>
              <tr><td>Play Store Support</td><td class="cell-muted">No</td><td class="cell-highlight">Yes</td></tr>
            </tbody>
          </table>
        </div>
        <div class="section-body">
          <p>The choice between GBWhatsApp and the official app depends on your priorities. If privacy controls and customization are important to you, GB WhatsApp offers significantly more. If stability and zero ban risk are your primary concerns, stick with the official app. <a href="/gb-vs-whatsapp-comparison/" class="inline-link">Full comparison →</a></p>
        </div>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-oldversions">
      <div class="section-inner">
        <p class="section-tag">Archive</p>
        <h2 id="sec-oldversions" class="section-title">GB WhatsApp Old Versions</h2>
        <div class="section-body">
          <p>Some users prefer older GBWhatsApp versions because they may work better on specific Android devices.</p>
          <p>We provide information about previous releases, including:</p>
        </div>
        <ul class="req-list">
          <li>GB WhatsApp v18.70</li>
          <li>GB WhatsApp v18.50</li>
          <li>GB WhatsApp v18.30</li>
          <li>GB WhatsApp v18.20</li>
        </ul>
        <div class="section-body">
          <p>Older versions can be useful when the newest update has compatibility problems or users prefer previous features.</p>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-safe">
      <div class="section-inner">
        <p class="section-tag">Account Safety</p>
        <h2 id="sec-safe" class="section-title">Is GB WhatsApp Safe to Use?</h2>
        <div class="section-body">
          <p>GBWhatsApp is a third-party modified application and is not available through official app stores.</p>
          <p>Before installing any APK file, users should consider:</p>
        </div>
        <ul class="req-list">
          <li>Download APK files from trusted sources</li>
          <li>Scan files before installation</li>
          <li>Keep regular chat backups</li>
          <li>Avoid sharing sensitive information through unofficial apps</li>
        </ul>
        <div class="section-body">
          <p>GB WhatsApp provides additional features, but users should understand that modified applications may have different security and update policies compared with official apps.</p>
          <p><a href="/ban-risk-analysis/" class="inline-link">Read full ban risk analysis</a> before making a decision. Understanding the real risk profile helps you use GB WhatsApp responsibly.</p>
        </div>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-pc">
      <div class="section-inner">
        <p class="section-tag">Devices</p>
        <h2 id="sec-pc" class="section-title">GBWhatsApp for PC and Windows</h2>
        <div class="section-body">
          <p>Although GBWhatsApp is designed mainly for Android devices, some users want to access it on Windows computers.</p>
          <p>GB WhatsApp can be used on PC through Android emulators.</p>
          <p>Common options include:</p>
        </div>
        <ul class="req-list">
          <li>Windows 11 support</li>
          <li>Windows 10 compatibility</li>
          <li>Android emulator installation</li>
        </ul>
        <div class="section-body">
          <p>Using an emulator allows users to run Android applications on desktop devices.</p>
        </div>
        <h2 class="subsection-title subsection-title--dark">GB WhatsApp Web</h2>
        <div class="section-body">
          <p>Some users prefer using <strong>GB WhatsApp Web</strong> to access their chats from a computer. Similar to WhatsApp Web, it allows you to send and receive messages through a browser while your phone stays connected to the internet.</p>
          <p>It is a convenient option for managing conversations on a larger screen without installing extra software.</p>
        </div>

        <h2 class="subsection-title subsection-title--dark">GBWhatsApp for Chromebook</h2>
        <div class="section-body">
          <p>Chromebook users can also use <strong>GB WhatsApp</strong> by installing the Android APK through supported Android app environments or an Android emulator.</p>
          <p>After installation, most GB WhatsApp features should work on ChromeOS, allowing users to send messages, share media, and manage chats directly from their Chromebook.</p>
        </div>

        <h2 class="subsection-title subsection-title--dark">Download GB WhatsApp for iOS</h2>
        <div class="section-body">
          <p><strong>GB WhatsApp</strong> is mainly designed for Android devices and is not available on the Apple App Store. Some iPhone users may try alternative methods to access similar features, but installation support and compatibility can vary.</p>
          <p>For the best experience, GB WhatsApp is recommended for compatible Android devices.</p>
        </div>

        <h2 class="subsection-title subsection-title--dark">GB WhatsApp for Mac</h2>
        <div class="section-body">
          <p>Mac users can access <strong>GB WhatsApp</strong> in different ways. One option is using an Android emulator to run the GB WhatsApp APK on macOS.</p>
          <p>Another option is using the web version through a browser, allowing users to send and receive messages while their phone remains connected to the internet.</p>
        </div>

        <h2 class="subsection-title subsection-title--dark">GB WhatsApp for iPad</h2>
        <div class="section-body">
          <p>iPad users can access <strong>GB WhatsApp</strong> through similar methods. The app may be used with third-party solutions or through a browser-based web version while keeping the connected phone online.</p>
          <p>This allows users to manage chats, send messages, and share media on a larger screen.</p>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-errors">
      <div class="section-inner">
        <p class="section-tag">Troubleshooting</p>
        <h2 id="sec-errors" class="section-title">Common GBWhatsApp Problems and Solutions</h2>
        <div class="section-body">
          <p>Some users may experience installation or update issues when using GBWhatsApp.</p>
          <p>Common problems include:</p>
        </div>

        <h3 class="error-fix-title">App Not Installed</h3>
        <ul class="req-list">
          <li>Enable <strong>Install from Unknown Sources</strong>.</li>
          <li>Remove any previous GB WhatsApp version.</li>
          <li>Make sure Android 4.4+ is supported.</li>
          <li>Ensure you have enough storage.</li>
          <li><a href="/app-not-installed-error/" class="inline-link"><strong>View Full Fix</strong></a> <strong>→</strong></li>
        </ul>

        <h3 class="error-fix-title">Restore Failed</h3>
        <ul class="req-list">
          <li>Use the built-in <strong>GB WhatsApp Backup</strong>.</li>
          <li>Don't restore it from Google Drive.</li>
          <li>Create a local backup before updating.</li>
          <li><a href="/restore-failed-error/" class="inline-link"><strong>View Full Fix</strong></a> <strong>→</strong></li>
        </ul>

        <h3 class="error-fix-title">Verification Problem</h3>
        <ul class="req-list">
          <li>Enter your phone number with the country code.</li>
          <li>Check your SMS or internet connection.</li>
          <li>Try <strong>Voice Verification</strong> if OTP doesn't arrive.</li>
          <li>Make sure your number isn't banned.</li>
          <li><a href="/verification-problem/" class="inline-link"><strong>View Full Fix</strong></a> <strong>→</strong></li>
        </ul>
      </div>
    </section>

    <section class="content-section" aria-labelledby="sec-mods">
      <div class="section-inner">
        <h2 id="sec-mods" class="section-title">Explore Other WhatsApp Mods</h2>
        <div class="mods-grid">
          <a href="/fmwhatsapp/" class="mod-item">
            <h3 class="mod-item-title">FMWhatsApp</h3>
            <img class="mod-logo" src="@/assets/mods/fmwhatsapp.webp" alt="FMWhatsApp" loading="lazy" width="56" height="56">
            <p>A popular WhatsApp mod with enhanced privacy, custom themes, and anti-revoke features.</p>
          </a>
          <a href="/yowhatsapp/" class="mod-item">
            <h3 class="mod-item-title">YoWhatsApp</h3>
            <img class="mod-logo" src="@/assets/mods/yowhatsapp.webp" alt="YoWhatsApp" loading="lazy" width="56" height="56">
            <p>Offers chat lock, hide views, custom fonts, and a wide selection of built-in themes.</p>
          </a>
          <a href="/whatsapp-plus/" class="mod-item">
            <h3 class="mod-item-title">WhatsApp Plus</h3>
            <img class="mod-logo" src="@/assets/mods/whatsapp-plus.webp" alt="WhatsApp Plus" loading="lazy" width="56" height="56">
            <p>Provides more customization options, larger media sharing limits, and additional privacy controls.</p>
          </a>
          <a href="/ogwhatsapp/" class="mod-item">
            <h3 class="mod-item-title">OGWhatsApp</h3>
            <img class="mod-logo" src="@/assets/mods/ogwhatsapp.webp" alt="OGWhatsApp" loading="lazy" width="56" height="56">
            <p>A lightweight WhatsApp mod focused on faster performance and essential privacy features.</p>
          </a>
        </div>
      </div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-usecases">
      <div class="section-inner"><p class="section-tag">Real World Use</p><h2 id="sec-usecases" class="section-title">Real Use Cases of GB WhatsApp</h2><div class="motivation-grid"><article class="motivation-card"><h3>Small Business Communication</h3><p>Small businesses use GB WhatsApp to manage customer inquiries with auto-reply, schedule follow-up messages, and maintain a separate work presence on the same device.</p><a href="/gb-whatsapp-for-small-business/" class="inline-link">Business guide</a></article><article class="motivation-card"><h3>Marketing Campaigns</h3><p>Marketers schedule promotional messages, use bulk messaging with delays, and track campaigns while hiding read receipts to monitor competitors discreetly.</p><a href="/gb-whatsapp-for-marketing/" class="inline-link">Marketing guide</a></article><article class="motivation-card"><h3>Students and Study Groups</h3><p>Students organize class groups, schedule study reminders, and use DND mode to focus during lectures while staying informed about urgent announcements.</p><a href="/gb-whatsapp-for-students/" class="inline-link">Student guide</a></article><article class="motivation-card"><h3>Bulk Messaging</h3><p>Community managers and support teams use bulk messaging with intentional delays to reach members without triggering WhatsApp spam detection.</p><a href="/bulk-messaging-guide/" class="inline-link">Bulk messaging guide</a></article></div></div>
    </section>

    <section class="content-section" aria-labelledby="sec-proscons">
      <div class="section-inner"><p class="section-tag">Honest Assessment</p><h2 id="sec-proscons" class="section-title">GB WhatsApp Pros and Cons</h2><div class="verdict-grid"><div class="verdict-card verdict-card--green"><div class="verdict-header"><p class="verdict-label">Pros</p></div><ul class="verdict-list"><li><strong>Rich feature set</strong> - privacy controls, automation, and themes the official app lacks.</li><li><strong>Free to use</strong> - no subscription, no ads, and a free APK download.</li><li><strong>Customization depth</strong> - themes, custom fonts, and layout changes.</li><li><strong>Independent distribution</strong> - works outside the Google Play Store.</li></ul></div><div class="verdict-card verdict-card--red"><div class="verdict-header"><p class="verdict-label">Cons</p></div><ul class="verdict-list"><li><strong>Ban risk</strong> - WhatsApp can temporarily or permanently restrict accounts.</li><li><strong>No Google Drive backup</strong> - local backups require more care.</li><li><strong>Manual security updates</strong> - new APKs must be installed manually.</li><li><strong>Unofficial app store</strong> - sideloading increases clone and malware risk.</li></ul></div></div></div>
    </section>

    <section class="content-section content-section--alt" aria-labelledby="sec-faq">
      <div class="section-inner">
        <p class="section-tag">Questions</p>
        <h2 id="sec-faq" class="section-title">Frequently Asked Questions (FAQs)</h2>
        <div class="faq-list" role="list">
          <div v-for="(item, index) in faqItems" :key="index" class="faq-item" :class="{ open: item.open }" role="listitem" @click="toggleFaq(item)">
            <div class="faq-q"><span>{{ item.q }}</span><svg class="faq-arrow" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M7 10l5 5 5-5z"/></svg></div>
            <div class="faq-a" v-show="item.open"><div v-html="item.a"></div></div>
          </div>
        </div>
      </div>
    </section>

    <section class="final-cta-section" aria-labelledby="cta-heading">
      <div class="final-cta-card"><div class="final-cta-text"><h2 id="cta-heading">Ready to Download GB WhatsApp?</h2><p>Get GB WhatsApp v18.80 with privacy controls, custom themes, and enhanced messaging tools for Android.</p></div><div class="final-cta-action"><a href="/download/" class="btn-primary btn-large" @click="downloadClick">Download Free APK</a><p class="final-meta">Free - 95 MB - Android 5.0+ - No root</p></div></div>
    </section>

  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import BreadcrumbNav from '@/components/BreadcrumbNav.vue';

export default {
  name: 'Home',
  components: { HeadNav, BreadcrumbNav },
  data() {
    return {
      apk: null,
      faqItems: [
        {
          q: 'Is GB WhatsApp legal?',
          a: `<p>Legality varies by jurisdiction. In most countries, using a <strong>modified WhatsApp app</strong> on your own device is a gray area rarely enforced against individual users. The developers who create and distribute <strong>GB WhatsApp</strong> carry more legal exposure than users who install it. Some regions have specific software-modification laws worth researching if you're in a highly regulated environment.</p>`,
          open: false,
        },
        {
          q: 'Is GB WhatsApp safe to use?',
          a: `<p>Safety depends primarily on where you download the APK from. A trusted build from an official source is broadly comparable in surface risk to any APK sideloaded app. The real risk comes from downloading from unofficial mirrors that may have repackaged the APK with malware. Additionally, <strong>GB WhatsApp</strong> does not receive WhatsApp's official security patches automatically, which matters more for users with elevated security needs than for typical users. Always use our <a href="/download/" class="inline-link">official download page</a> to get the safest build.</p>`,
          open: false,
        },
        {
          q: 'Can I use GB WhatsApp on iPhone?',
          a: `<p>No stable <strong>GB WhatsApp</strong> equivalent exists for iOS. Apple's restrictions make modding significantly harder. Enterprise certificate-based iOS solutions exist but are unreliable — certificates get revoked frequently, breaking the app without warning. For iPhone users who want WhatsApp modification features, a budget secondary Android device is the most practical option.</p>`,
          open: false,
        },
        {
          q: 'How do I avoid getting banned on GB WhatsApp?',
          a: `<p>No guarantee can be made — WhatsApp's ban detection evolves and no anti-ban feature is foolproof. Practical risk-reduction steps: use a recent <strong>GB WhatsApp</strong> build from <a href="/download/" class="inline-link">our download page</a>, avoid bulk messaging to unsaved contacts, don't join many groups rapidly, and maintain a backup communication plan. If you are temporarily banned, switching to official WhatsApp until the suspension lifts gives the best recovery outcome.</p>`,
          open: false,
        },
        {
          q: 'Can I use GB WhatsApp and official WhatsApp at the same time?',
          a: `<p>Running two WhatsApp clients (official + mod) simultaneously on the same device and phone number is generally safe. However, logging into the <strong>same phone number on two devices at once</strong> may flag your account. Use <strong>GB WhatsApp</strong> on your primary device and official WhatsApp on a secondary device to minimize any overlap risk.</p>`,
          open: false,
        },
        {
          q: 'How often does GB WhatsApp update?',
          a: `<p>Between 8 and 14 meaningful updates per year, typically triggered by WhatsApp server changes or significant bugs. There's no fixed release schedule. Major WhatsApp updates (new encryption, verification changes) tend to prompt the fastest patches. Major WhatsApp version updates (e.g., 3.0 to 4.0) can take 1–3 weeks to get a compatible GB WhatsApp build.</p>`,
          open: false,
        },
        {
          q: 'Will GB WhatsApp drain my battery faster?',
          a: `<p>Not significantly during normal use — both apps maintain a persistent server connection that is the primary battery consumer. However, aggressive battery management on Xiaomi, Huawei, and OPPO devices may terminate GB WhatsApp in the background, causing notification delays. Whitelisting <strong>GB WhatsApp</strong> in your device's battery settings resolves most issues. Go to Settings → Battery → App launch → GB WhatsApp → set to "Manage manually" and enable all toggles.</p>`,
          open: false,
        },
        {
          q: 'Can I restore my chat history from official WhatsApp to GB WhatsApp?',
          a: `<p>You can restore from a <a href="/how-to-backup-and-restore-gb-whatsapp/" class="inline-link"><strong>GB WhatsApp local backup</strong></a> but <strong>not</strong> from an official WhatsApp Google Drive backup. The two backup formats are incompatible. Before switching, create a full <a href="/how-to-backup-and-restore-gb-whatsapp/" class="inline-link">local backup</a> within your current <strong>GB WhatsApp</strong> installation. Do this regularly — at least monthly — to protect your message history.</p>`,
          open: false,
        },
        {
          q: 'What is the difference between GB WhatsApp and WhatsApp Plus?',
          a: `<p><a href="/whatsapp-plus/" class="inline-link"><strong>WhatsApp Plus</strong></a> is another popular WhatsApp mod with its own feature set. The key differences are: GB WhatsApp typically receives updates faster after WhatsApp releases new versions, while WhatsApp Plus often focuses more on UI customization. Feature-wise they overlap heavily — both offer theme customization, privacy controls, and anti-delete features. Choose based on which one you find more stable in your testing.</p>`,
          open: false,
        },
        {
          q: 'Does GB WhatsApp support video calls and voice calls?',
          a: `<p><strong>GB WhatsApp</strong> supports the same video and voice call features as the official WhatsApp, because calls are routed through WhatsApp's own servers regardless of which client you use. The mod does not add new call features, but it also does not interfere with existing call functionality. Some users report slightly more stable call connections on GB WhatsApp due to its lightweight codebase.</p>`,
          open: false,
        },
        {
          q: 'How do I update GB WhatsApp without losing my chats?',
          a: `<p>Always create a <a href="/how-to-backup-and-restore-gb-whatsapp/" class="inline-link"><strong>local backup</strong></a> before updating. Then uninstall the old version, download the new APK from <a href="/download/" class="inline-link">our download page</a>, install it, and immediately create another backup of the new installation. GB WhatsApp's backup is stored locally in your device's internal storage, not on Google Drive. Follow our <a href="/how-to-update-gb-whatsapp/" class="inline-link">update guide</a> for the safest procedure.</p>`,
          open: false,
        },
        {
          q: 'Is there a GB WhatsApp for PC / Windows?',
          a: `<p>There is no official <strong>GB WhatsApp PC client</strong>. However, you can use GB WhatsApp on a PC by running Android emulation software such as BlueStacks, LDPlayer, or NoxPlayer. Install the APK inside the emulator just as you would on a real Android device. Note that ban risk may be higher when using emulators due to detection of non-standard device signatures.</p>`,
          open: false,
        },
      ],
    };
  },
  computed: {
    locale() {
      const name = this.$route?.name || '';
      const lang = name.split('-')[0];
      return ['en', 'es', 'hi', 'pt', 'id'].includes(lang) ? lang : 'en';
    },
    selectedLanguage() {
      return this.locale;
    },
  },
  mounted() {
    const from = this.$global.GetQueryString('from') || 'gb';
    const filename = this.$global.GetQueryString('filename') || 'gb';
    if (from) {
      this.fetchAPK(from, filename);
    } else {
      this.fetchOfficialAPK();
    }
  },
  methods: {
    downloadClick() {
      this.$router.push({ name: `${this.locale}-download` });
    },
    gotodownload() {
      this.$router.push({ name: `${this.locale}-download` });
    },
    fetchAPK(from, filename) {
      this.$server.getAPPInfo({ promotionChannel: from, promotionName: filename })
        .then((res) => { if (res.code === 200) this.apk = res.data.apk; })
        .catch(() => { this.apk = process.env.VUE_APP_GBLINK; });
    },
    fetchOfficialAPK() {
      this.$server.getOfficalApk({ domain: 'gbwhatsapp.chat', appName: 'GB_gbwhatsapp.chat' })
        .then((res) => { if (res.code === 200) this.apk = res.data.apk; })
        .catch(() => { this.apk = process.env.VUE_APP_GBLINK; });
    },
    toggleFaq(item) {
      item.open = !item.open;
    },
  },
};
</script>

<style lang="scss" scoped>
/* ============================================================
   Fonts — Fraunces (display serif) + Geist Sans
   ============================================================ */
@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;0,9..144,700;0,9..144,800;1,9..144,400&family=Geist:wght@300;400;500;600;700&display=swap');

$font-display: 'Fraunces', Georgia, serif;
$font-body:   'Geist', system-ui, sans-serif;

// 深海蓝琥珀主题
$brand:        #0F2347;
$brand-mid:    #1E3A5F;
$brand-soft:   #3B82C4;
$brand-pale:   #EBF2FC;
$brand-light:  #F0F5FB;
$accent:       #F59E0B;    // 琥珀金
$accent-light: #FCD34D;
$text-main:    #0F2347;
$text-body:    #334155;
$text-muted:   #64748b;
$text-faint:   #94a3b8;
$text-ghost:   rgba(255,255,255,0.75);
$border:       rgba(30,58,95,0.08);
$border-mid:   rgba(30,58,95,0.15);
$border-glass: rgba(255,255,255,0.12);
$shadow-sm:    0 2px 12px rgba(15,35,71,0.06);
$shadow-md:    0 4px 24px rgba(15,35,71,0.1);
$shadow-lg:    0 16px 48px rgba(15,35,71,0.18);

/* ============================================================
   Base
   ============================================================ */
.home {
  font-family: $font-body;
  color: $text-body;
  background: #f4f7fb;
  min-height: 100vh;
}

.site-main {
  max-width: min(1180px, 100%);
  margin: 0 auto;
  padding: 0 24px;
  overflow-x: clip;
}

/* ============================================================
   HERO — WhatsApp 绿色主调（无黑底）
   ============================================================ */
.hero {
  position: relative;
  background: #128C7E;
  min-height: auto;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 36px 24px 44px;
  margin: 12px 0;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      165deg,
      #25D366 0%,
      #128C7E 38%,
      #075E54 72%,
      #064e3b 100%
    );
    z-index: 0;
  }
}

// 背景装饰层
.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  overflow: hidden;
}

.hero-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);

  &--1 {
    width: 520px;
    height: 520px;
    background: radial-gradient(circle, rgba(37, 211, 102, 0.55) 0%, transparent 68%);
    top: -160px;
    right: -80px;
    opacity: 0.35;
    animation: orbFloat1 12s ease-in-out infinite;
  }

  &--2 {
    width: 380px;
    height: 380px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.35) 0%, transparent 70%);
    bottom: -120px;
    left: -60px;
    opacity: 0.2;
    animation: orbFloat2 15s ease-in-out infinite;
  }

  &--3 {
    width: 280px;
    height: 280px;
    background: radial-gradient(circle, rgba(18, 140, 126, 0.5) 0%, transparent 70%);
    top: 35%;
    left: 35%;
    opacity: 0.22;
    animation: orbFloat3 10s ease-in-out infinite;
  }
}

@keyframes orbFloat1 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(-30px, 30px) scale(1.05); }
  66% { transform: translate(20px, -20px) scale(0.97); }
}

@keyframes orbFloat2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(40px, -30px); }
}

@keyframes orbFloat3 {
  0%, 100% { opacity: 0.04; }
  50% { opacity: 0.08; }
}

.hero-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 85% 85% at 50% 45%, black 0%, transparent 100%);
  opacity: 0.85;
}

.hero-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  text-align: center;
  animation: heroEnter 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes heroEnter {
  from { opacity: 0; transform: translateY(32px); }
  to   { opacity: 1; transform: translateY(0); }
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  animation: contentEnter 1s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both;
}

.hero-logo-wrap {
  margin: 0 auto 20px;
  position: relative;
  z-index: 1;
  animation: heroLogoIn 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;

  &::after {
    content: '';
    position: absolute;
    inset: -3px;
    border-radius: 28px;
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.08));
    z-index: -1;
    opacity: 0.95;
  }
}

@keyframes heroLogoIn {
  from { opacity: 0; transform: scale(0.92) translateY(12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.hero-logo {
  display: block;
  width: 112px;
  height: 112px;
  border-radius: 26px;
  object-fit: cover;
  box-shadow:
    0 16px 40px rgba(7, 94, 84, 0.45),
    0 0 0 1px rgba(255, 255, 255, 0.25) inset;
}

@keyframes contentEnter {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.hero-title {
  font-family: $font-display;
  font-size: clamp(2rem, 4.2vw, 3rem);
  font-weight: 800;
  line-height: 1.2;
  color: #ffffff;
  margin: 0 auto 20px;
  letter-spacing: 0.01em;
  word-spacing: normal;
  text-align: center;
  max-width: 16em;
}

.hero-desc {
  font-size: 16px;
  line-height: 1.75;
  color: rgba(255,255,255,0.78);
  margin: 0 auto 22px;
  max-width: 40rem;
  font-weight: 400;
  text-align: center;
  letter-spacing: normal;
  word-spacing: normal;
}

.hero-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
}

.hero-facts {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  margin-top: 28px;
}

.hero-fact {
  min-height: 88px;
  padding: 12px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  overflow: visible;
}

.hero-fact-icon {
  display: block;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.72);
  flex-shrink: 0;
}

.hero-fact-text {
  margin: 0 auto;
  width: 100%;
  font-size: 12px;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.88);
  text-align: center;
  word-break: normal;
  overflow-wrap: break-word;

  span {
    display: block;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 2px;
    text-align: center;
  }

  strong {
    display: block;
    font-weight: 700;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
  }
}

.btn-download-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #25D366;
  color: #111827;
  border: none;
  padding: 15px 48px;
  border-radius: 10px;
  font-family: $font-body;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);

  &:hover {
    background: #2fe072;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22);
  }

  &:active { transform: translateY(0); }
}

.btn-learn-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #93c5fd;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-family: $font-body;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.2s ease;
  padding: 0;

  &:hover {
    color: #bfdbfe;
  }
}

// ===== 右：玻璃态信息卡 =====
.hero-glass-card {
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid $border-glass;
  border-radius: 24px;
  padding: 32px;
  box-shadow:
    0 24px 64px rgba(0,0,0,0.3),
    0 0 0 1px rgba(255,255,255,0.05) inset,
    0 1px 0 rgba(255,255,255,0.1) inset;
  animation: cardEnter 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s both;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(245,158,11,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
}

@keyframes cardEnter {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.glass-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
}

.glass-app-icon {
  img {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.3);
    display: block;
  }
}

.glass-app-name {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.glass-app-title {
  font-family: $font-body;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.glass-app-sub {
  font-size: 12px;
  color: rgba(255,255,255,0.45);
  font-weight: 400;
}

.glass-stats {
  display: flex;
  gap: 0;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;
}

.glass-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px;
  gap: 4px;
  position: relative;

  & + & {
    border-left: 1px solid rgba(255,255,255,0.07);
  }
}

.glass-stat-val {
  font-family: $font-body;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.glass-stat-lbl {
  font-size: 10px;
  color: rgba(255,255,255,0.4);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.glass-badges {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.glass-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 50px;
  letter-spacing: 0.02em;

  &--works {
    background: rgba(22, 163, 74, 0.2);
    border: 1px solid rgba(22, 163, 74, 0.35);
    color: #4ade80;
  }

  &--info {
    background: rgba(96, 165, 250, 0.15);
    border: 1px solid rgba(96, 165, 250, 0.25);
    color: #93c5fd;
  }
}

.glass-download-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: $accent;
  color: #0F2347;
  border: none;
  border-radius: 12px;
  padding: 15px;
  font-family: $font-body;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 4px 20px rgba(245,158,11,0.3);

  &:hover {
    background: #D97706;
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(245,158,11,0.4);
  }

  &:active { transform: translateY(0); }
}

.glass-footnote {
  text-align: center;
  font-size: 11px;
  color: rgba(255,255,255,0.3);
  margin: 10px 0 0;
  font-weight: 400;
}

/* ============================================================
   内容区块通用样式
   ============================================================ */
.content-section {
  padding: 54px 0;
  position: relative;

  // &::after {
  //   content: '';
  //   display: block;
  //   width: 100%;
  //   height: 1px;
  //   background: linear-gradient(90deg, transparent, rgba(15,35,71,0.08), transparent);
  //   margin-top: 72px;
  // }

  &:last-of-type::after { display: none; }

  &--alt {
    background: #f6f8fb;
    border-radius: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;

    &::after {
      background: linear-gradient(90deg, transparent, rgba(30,58,95,0.06), transparent);
    }
  }

  &--brand-green {
    background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 58%, #f6f8fb 100%);
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;

    &::after {
      background: linear-gradient(90deg, transparent, rgba(16, 185, 129, 0.14), transparent);
    }

    .compare-table th {
      background: linear-gradient(135deg, #047857 0%, #059669 100%);
    }

    .section-body strong {
      color: #065f46;
    }
  }
}

.section-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;

  &--brand {
    max-width: 880px;
  }
}

.section-head-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 4px;
}

.section-brand-mark {
  margin-bottom: 12px;
}

.section-mini-logo {
  display: block;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(5, 150, 105, 0.22);
}

.section-tag--green {
  color: #059669;

  &::before {
    background: #10b981;
  }
}

.section-title--green {
  color: #065f46;
  text-align: center;
}

.section-title--spaced {
  margin-top: 44px;
}

.section-body--readable {
  text-align: left;
}

.inline-link--green {
  color: #047857;
  text-decoration-color: rgba(4, 120, 87, 0.35);

  &:hover {
    color: #065f46;
    text-decoration-color: #065f46;
  }
}

.inline-callout--green {
  background: #ecfdf5;
  border: 1px solid rgba(16, 185, 129, 0.28);
  border-left: 3px solid #10b981;
  color: #065f46;

  .callout-icon {
    color: #059669;
  }

  .inline-link {
    color: #047857;
    text-decoration-color: rgba(4, 120, 87, 0.35);

    &:hover {
      color: #065f46;
      text-decoration-color: #065f46;
    }
  }
}

.subsection-title {
  font-family: $font-body;
  font-size: clamp(1.08rem, 2vw, 1.26rem);
  font-weight: 700;
  color: #047857;
  margin: 26px 0 10px;
  line-height: 1.32;
  letter-spacing: 0;
  text-align: left;
}

.subsection-title--dark {
  color: $text-main;
  margin-top: 30px;
  margin-bottom: 10px;
}

.error-fix-title {
  font-family: $font-body;
  font-size: 1.05rem;
  font-weight: 700;
  color: $text-main;
  margin: 22px 0 8px;
  line-height: 1.35;
}

.subsection-title--spaced {
  margin-top: 40px;
}

.subsection-kicker {
  font-size: 14px;
  margin: 0 0 16px;
  text-align: left;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: $font-body;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: $accent;
  margin-bottom: 14px;

  &::before {
    content: '';
    display: block;
    width: 18px;
    height: 2px;
    background: $accent;
    border-radius: 2px;
    flex-shrink: 0;
  }
}

.section-title {
  font-family: $font-display;
  font-size: clamp(1.55rem, 2.6vw, 2.08rem);
  font-weight: 700;
  color: $text-main;
  margin: 0 0 22px;
  line-height: 1.18;
  letter-spacing: 0;
}

.section-body + .section-title {
  margin-top: 38px;
}

.section-body {
  p {
    font-size: 15.5px;
    line-height: 1.78;
    color: $text-body;
    margin: 0 0 14px;

    &:last-child { margin-bottom: 0; }

    strong {
      color: $text-main;
      font-weight: 700;
    }

    a.inline-link {
      color: #2563eb;
      font-weight: 700;
      text-decoration: underline;
      text-underline-offset: 3px;
      text-decoration-color: rgba(37, 99, 235, 0.35);

      &:hover {
        color: #1d4ed8;
        text-decoration-color: #1d4ed8;
      }
    }

    strong a.inline-link {
      font-weight: 700;
    }
  }
}

/* ============================================================
   内联链接
   ============================================================ */
.inline-link {
  color: $brand-mid;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-weight: 500;
  text-decoration-color: rgba(30,58,95,0.3);
  transition: color 0.18s ease, text-decoration-color 0.18s ease;

  &:hover {
    color: $brand;
    text-decoration-color: $brand;
  }
}

/* ============================================================
   提示卡片
   ============================================================ */
.inline-callout {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.7;
  margin-top: 28px;

  .callout-icon {
    flex-shrink: 0;
    margin-top: 1px;
  }

  &--disclaimer {
    background: #FFFBEB;
    border: 1px solid rgba(245,158,11,0.25);
    border-left: 3px solid $accent;
    color: #92400e;
    .callout-icon { color: $accent; }
  }

  &--neutral {
    background: #EBF2FC;
    border: 1px solid rgba(30,58,95,0.12);
    border-left: 3px solid $brand-mid;
    color: $text-body;
    .callout-icon { color: $brand-mid; }
  }
}

/* ============================================================
   功能卡片网格
   ============================================================ */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 26px;

  &--2col {
    grid-template-columns: repeat(2, 1fr);
  }
}

.feature-card {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  padding: 22px;
  box-shadow: 0 1px 8px rgba(15,35,71,0.035);
  transition: box-shadow 0.22s ease, border-color 0.22s ease, transform 0.22s ease;

  &:hover {
    box-shadow: 0 6px 22px rgba(15,35,71,0.075);
    border-color: rgba(30,58,95,0.16);
    transform: translateY(-2px);
  }

  h3 {
    font-family: $font-body;
    font-size: 14.5px;
    font-weight: 700;
    color: $text-main;
    margin: 12px 0 7px;
  }

  p {
    font-size: 13.5px;
    line-height: 1.7;
    color: $text-muted;
    margin: 0 0 14px;
  }
}

.feature-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #EBF2FC 0%, #F0F5FB 100%);
  border: 1px solid rgba(30,58,95,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $brand-mid;
}

.feature-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 11px;
  border-radius: 50px;
  letter-spacing: 0.04em;

  &--works {
    background: rgba(22,163,74,0.1);
    border: 1px solid rgba(22,163,74,0.2);
    color: #16a34a;
  }

  &--mixed {
    background: rgba(59,130,196,0.1);
    border: 1px solid rgba(59,130,196,0.2);
    color: #2563eb;
  }
}

/* ============================================================
   引导/下载信息网格
   ============================================================ */
.download-info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 24px;
  align-items: start;
  max-width: 640px;
}

.download-info-card {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(15,35,71,0.04);
}

.download-info-card--padded {
  padding: 22px;
}

.card-title {
  font-family: $font-body;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 700;
  color: $text-main;
  margin: 0 0 16px;
}

.download-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid rgba(15,35,71,0.06);

  &:last-child { border-bottom: none; }
}

.download-info-label {
  font-size: 12.5px;
  color: $text-faint;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.download-info-value {
  font-size: 14px;
  font-weight: 600;
  color: $text-main;
}

.download-action-card {
  background: linear-gradient(145deg, #0F2347 0%, #1E3A5F 100%);
  border-radius: 20px;
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  box-shadow: 0 16px 48px rgba(15,35,71,0.2);

  h3 {
    font-family: $font-display;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
  }

  p {
    font-size: 13.5px;
    color: rgba(255,255,255,0.65);
    line-height: 1.6;
    margin: 0;
  }

  .download-app-icon {
    .dl-app-icon {
      width: 72px;
      height: 72px;
      border-radius: 18px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.25);
      display: block;
    }
  }
}

.download-action-meta {
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  margin: 0;
}

.btn-link-card {
  display: inline-block;
  margin-top: 14px;
  font-size: 13px;
  font-weight: 600;
  color: $brand-mid;
  text-decoration: none;
  font-family: $font-body;
  transition: color 0.18s ease;

  &:hover {
    color: $brand;
    text-decoration: underline;
  }
}

/* ============================================================
   故障排除网格
   ============================================================ */
.troubleshoot-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 24px;
}

.troubleshoot-card {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  padding: 22px;
  box-shadow: 0 1px 8px rgba(15,35,71,0.035);
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 6px 22px rgba(15,35,71,0.075);
    transform: translateY(-2px);
  }

  h3 {
    font-family: $font-body;
    font-size: 15px;
    font-weight: 700;
    color: $text-main;
    margin: 0 0 14px;
  }

  .troubleshoot-list li {
    font-size: 13px;
    line-height: 1.7;
    color: $text-muted;
    padding-left: 14px;
    position: relative;
    margin-bottom: 6px;

    &::before {
      content: '–';
      position: absolute;
      left: 0;
      color: $brand-soft;
    }

    strong { color: $text-main; }
  }

  .inline-link {
    color: $brand-mid;
    text-decoration: underline;
    font-weight: 500;
  }
}

.troubleshoot-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.numbered-list,
.mini-list {
  margin: 16px 0 0;
  padding-left: 22px;

  li {
    font-size: 14px;
    line-height: 1.75;
    color: $text-body;
    margin-bottom: 8px;
  }
}

.numbered-list {
  padding: 20px 22px 20px 42px;
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  box-shadow: 0 1px 8px rgba(15,35,71,0.04);
}

/* 安装步骤 Timeline */
.install-timeline {
  list-style: none;
  margin: 18px 0 0;
  padding: 8px 0 4px;
  counter-reset: install-step;
}

.install-timeline-item {
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 14px;
  align-items: start;
  padding: 0 0 24px;
  counter-increment: install-step;

  &:last-child {
    padding-bottom: 8px;

    &::before {
      display: none;
    }
  }

  /* 竖线 */
  &::before {
    content: '';
    position: absolute;
    left: 17px;
    top: 36px;
    bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, rgba(37, 211, 102, 0.55), rgba(37, 211, 102, 0.12));
  }
}

.install-timeline-dot {
  position: relative;
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(145deg, #25D366 0%, #128C7E 100%);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(18, 140, 126, 0.28);
  flex-shrink: 0;

  &::after {
    content: counter(install-step);
  }
}

.install-timeline-body {
  padding-top: 7px;
  font-size: 15px;
  line-height: 1.65;
  color: $text-body;

  strong {
    color: $text-main;
    font-weight: 700;
  }
}

.install-note {
  margin: 8px 0 0;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.65;
  color: $text-muted;
  background: #f8fafc;
  border: 1px solid $border;
  border-radius: 10px;

  strong {
    color: $text-main;
    font-weight: 700;
  }
}

.req-list {
  list-style: none;
  margin: 8px 0 18px;
  padding: 0;
  padding-inline-start: 0;
  margin-left: 0 !important;
  padding-left: 0 !important;

  li {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    margin: 0;
    padding: 5px 0;
    font-size: 15px;
    line-height: 1.7;
    color: $text-body;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 6px;
      height: 6px;
      margin-top: 0.55em;
      border-radius: 50%;
      background: #3B82C4;
    }

    strong {
      color: $text-main;
      font-weight: 700;
    }

    a.inline-link {
      color: #2563eb;
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 3px;
      text-decoration-color: rgba(37, 99, 235, 0.35);

      &:hover {
        color: #1d4ed8;
        text-decoration-color: #1d4ed8;
      }
    }
  }
}

/* 文档步骤列表（可嵌套） */
.doc-steps {
  list-style: none;
  margin: 12px 0 24px;
  padding: 0;
  counter-reset: doc-step;

  > li {
    position: relative;
    padding: 0 0 22px 44px;
    counter-increment: doc-step;
    font-size: 15px;
    line-height: 1.7;
    color: $text-body;

    &:last-child {
      padding-bottom: 0;
    }

    &::before {
      content: counter(doc-step);
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: linear-gradient(145deg, #25D366 0%, #128C7E 100%);
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 3px 10px rgba(18, 140, 126, 0.25);
    }

    > strong {
      display: block;
      color: $text-main;
      font-weight: 700;
      margin-bottom: 4px;
      padding-top: 4px;
    }

    .req-list {
      margin: 6px 0 0;
    }
  }

  &--simple > li {
    > strong {
      display: inline;
      margin-bottom: 0;
      padding-top: 0;
    }
  }
}

/* 无损更新指南 — 丰富卡片 Timeline */
.update-guide {
  list-style: none;
  margin: 16px 0 28px;
  padding: 0;
  counter-reset: update-step;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.update-guide-card {
  position: relative;
  margin: 0;
  padding: 20px 20px 18px 22px;
  background: #ffffff;
  border: 1px solid rgba(15, 35, 71, 0.08);
  border-radius: 12px;
  box-shadow: 0 1px 8px rgba(15, 35, 71, 0.04);
  counter-increment: update-step;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 14px;
    bottom: 14px;
    width: 4px;
    border-radius: 0 4px 4px 0;
    background: linear-gradient(180deg, #25D366 0%, #128C7E 100%);
  }

  &:hover {
    border-color: rgba(18, 140, 126, 0.28);
    box-shadow: 0 6px 22px rgba(18, 140, 126, 0.08);
    transform: translateY(-2px);
  }
}

.update-guide-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.update-guide-num {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(145deg, #25D366 0%, #0f766e 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(18, 140, 126, 0.28);

  &::after {
    content: counter(update-step);
  }
}

.update-guide-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.update-guide-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #0f766e;
}

.update-guide-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  color: $text-main;
}

.update-guide-list {
  list-style: none;
  margin: 0;
  padding: 0 0 0 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > li {
    position: relative;
    margin: 0;
    padding: 0 0 0 22px;
    font-size: 14.5px;
    line-height: 1.65;
    color: $text-body;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.55em;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #3B82C4;
    }

    strong {
      color: $text-main;
      font-weight: 700;
    }
  }
}

.update-guide-warn {
  margin-top: 4px !important;
  padding: 12px 14px 12px 34px !important;
  background: #fffbeb;
  border: 1px solid rgba(245, 158, 11, 0.28);
  border-radius: 12px;
  color: #92400e !important;

  &::before {
    left: 14px !important;
    top: 1.15em !important;
    width: 8px !important;
    height: 8px !important;
    background: #f59e0b !important;
  }

  strong {
    color: #92400e !important;
  }
}

/* 更新失败排查面板 */
.fail-panel {
  margin: 12px 0 28px;
  padding: 20px 22px 18px;
  background: linear-gradient(165deg, #fffbeb 0%, #ffffff 55%);
  border: 1px solid rgba(245, 158, 11, 0.22);
  border-radius: 12px;
  box-shadow: 0 1px 8px rgba(15, 35, 71, 0.04);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 12px;
    width: 4px;
    border-radius: 0 4px 4px 0;
    background: linear-gradient(180deg, #F59E0B 0%, #D97706 100%);
  }
}

.fail-panel-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.fail-panel-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fail-panel-lead {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: $text-main;
  line-height: 1.4;
}

.fail-panel-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > li {
    position: relative;
    margin: 0;
    padding: 10px 14px 10px 36px;
    font-size: 14.5px;
    line-height: 1.65;
    color: $text-body;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(15, 35, 71, 0.06);
    border-radius: 10px;

    &::before {
      content: '';
      position: absolute;
      left: 14px;
      top: 1.05em;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #F59E0B;
    }

    strong {
      color: $text-main;
      font-weight: 700;
    }
  }
}

.content-columns {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(260px, 0.8fr);
  gap: 20px;
  align-items: start;
}

.inline-callout--stacked {
  flex-direction: column;
  gap: 8px;

  strong {
    color: $text-main;
  }
}

.version-grid,
.platform-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
}

.platform-list {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.version-card,
.platform-list article {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 8px rgba(15,35,71,0.035);

  h3 {
    font-family: $font-body;
    font-size: 14px;
    font-weight: 700;
    color: $text-main;
    margin: 0 0 8px;
  }

  p {
    font-size: 13.5px;
    line-height: 1.7;
    color: $text-muted;
    margin: 0;
  }
}

.detail-table-wrap {
  margin-top: 0;
  border-radius: 12px;
  box-shadow: none;
}

.detail-table th {
  background: #f8fafc;
  color: $text-main;
}

.mods-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 24px;
}

.mod-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  min-width: 0;
  padding: 18px 16px;
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 5px 18px rgba(15, 35, 71, 0.07);
    border-color: rgba(30, 58, 95, 0.18);
    transform: translateY(-2px);

    .mod-item-title {
      color: $brand-mid;
    }
  }

  .mod-item-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: $text-main;
    line-height: 1.3;
  }

  .mod-logo {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    object-fit: cover;
    box-shadow: 0 4px 16px rgba(15, 35, 71, 0.1);
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
    color: $text-muted;
  }
}

/* ============================================================
   风险卡片
   ============================================================ */
.risk-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 24px;
}

.risk-card {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  padding: 22px;
  display: flex;
  gap: 16px;
  transition: box-shadow 0.2s ease;

  &:hover { box-shadow: 0 5px 18px rgba(15,35,71,0.07); }
}

.risk-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &--warn { background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.2); color: #D97706; }
  &--danger { background: rgba(220,38,38,0.08); border: 1px solid rgba(220,38,38,0.15); color: #DC2626; }
}

.risk-content {
  flex: 1;

  h3 {
    font-family: $font-body;
    font-size: 15px;
    font-weight: 700;
    color: $text-main;
    margin: 0 0 8px;
  }

  p {
    font-size: 13.5px;
    line-height: 1.7;
    color: $text-muted;
    margin: 0 0 10px;
  }

  .inline-link {
    font-size: 13px;
    color: $brand-mid;
    text-decoration: underline;
    font-weight: 500;
  }
}

/* ============================================================
   使用场景网格
   ============================================================ */
.motivation-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 24px;
}

.motivation-card {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 12px;
  padding: 22px;
  box-shadow: 0 1px 8px rgba(15,35,71,0.035);
  transition: box-shadow 0.22s ease, transform 0.22s ease;

  &:hover {
    box-shadow: 0 6px 22px rgba(15,35,71,0.075);
    transform: translateY(-2px);
  }

  h3 {
    font-family: $font-body;
    font-size: 14.5px;
    font-weight: 700;
    color: $text-main;
    margin: 14px 0 8px;
  }

  p {
    font-size: 13.5px;
    line-height: 1.75;
    color: $text-muted;
    margin: 0 0 12px;
  }

  .inline-link {
    font-size: 13px;
    font-weight: 600;
    color: $brand-mid;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;

    &::after {
      content: '→';
      transition: transform 0.18s ease;
    }

    &:hover {
      color: $brand;
      &::after { transform: translateX(3px); }
    }
  }
}

.motivation-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #EBF2FC, #F0F5FB);
  border: 1px solid rgba(30,58,95,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $brand-mid;
}

/* ============================================================
   对比表格
   ============================================================ */
.compare-table-wrap {
  overflow-x: auto;
  max-width: 100%;
  margin: 20px 0 22px;
  border-radius: 12px;
  border: 1px solid $border;
  box-shadow: 0 1px 10px rgba(15, 35, 71, 0.045);
}

.compare-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;

  th, td {
    padding: 13px 16px;
    text-align: left;
    border-bottom: 1px solid $border;
    font-size: 13.5px;
    vertical-align: top;
  }

  th {
    background: linear-gradient(135deg, #0f766e 0%, #128C7E 100%);
    color: #ffffff;
    font-family: $font-body;
    font-weight: 600;
    font-size: 13px;

    .app-name { display: block; font-size: 15px; font-weight: 700; margin-bottom: 2px; }
    .app-type { display: block; font-size: 11px; opacity: 0.55; font-weight: 400; letter-spacing: 0.03em; }
  }

  tbody tr:last-child td { border-bottom: none; }
  tbody tr:nth-child(even) td { background: #FAFBFD; }

  td:first-child {
    font-weight: 600;
    color: $text-main;
    white-space: nowrap;
  }
}

.cell-highlight { color: #16a34a; font-weight: 600; }
.cell-muted { color: $text-muted; }
.cell-warn { color: #D97706; font-weight: 600; }

.compare-note {
  font-size: 14px;
  line-height: 1.8;
  color: $text-muted;
  margin: 16px 0 0;
  padding: 0;
}

.compare-cta {
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.compare-cta-text {
  font-size: 15px;
  font-weight: 500;
  color: $text-main;
  margin: 0;
}

.btn-outline-card {
  display: inline-block;
  margin-top: 10px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  font-family: $font-body;
  color: $brand-mid;
  border: 1.5px solid rgba(15,35,71,0.2);
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: $brand-mid;
    border-color: $brand-mid;
    color: #ffffff;
  }
}

/* ============================================================
   优缺点
   ============================================================ */
.verdict-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 24px;
}

.verdict-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid $border;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(15,35,71,0.04);
}

.verdict-header {
  padding: 16px 22px;
  border-bottom: 1px solid $border;
}

.verdict-label {
  font-family: $font-body;
  font-size: 12.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.verdict-card--green .verdict-header {
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border-bottom-color: rgba(22,163,74,0.15);
  .verdict-label { color: #16a34a; }
}

.verdict-card--red .verdict-header {
  background: linear-gradient(135deg, #fef2f2, #fee2e2);
  border-bottom-color: rgba(220,38,38,0.1);
  .verdict-label { color: #DC2626; }
}

.verdict-list {
  list-style: none;
  margin: 0;
  padding: 18px 22px;

  li {
    font-size: 13.5px;
    line-height: 1.75;
    color: $text-body;
    padding: 8px 0;
    border-bottom: 1px solid rgba(15,35,71,0.05);

    &:last-child { border-bottom: none; padding-bottom: 0; }
    &:first-child { padding-top: 0; }

    strong { color: $text-main; }
  }
}

/* ============================================================
   FAQ
   ============================================================ */
.faq-list {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-item {
  background: #ffffff;
  border: 1px solid $border;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(15,35,71,0.065);
    border-color: rgba(30,58,95,0.18);
  }

  &.open {
    box-shadow: 0 5px 18px rgba(15,35,71,0.08);
    border-color: rgba(30,58,95,0.22);
  }
}

.faq-q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  font-family: $font-body;
  font-size: 14.5px;
  font-weight: 600;
  color: $text-main;
  gap: 16px;

  .faq-arrow {
    flex-shrink: 0;
    color: $text-faint;
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
}

.faq-item.open .faq-q .faq-arrow {
  transform: rotate(180deg);
  color: $accent;
}

.faq-a {
  padding: 0 20px 18px;

  p {
    font-size: 14px;
    line-height: 1.85;
    color: $text-body;
    margin: 0;
  }
}

section.content-section[aria-labelledby="sec-faq"] {
  padding-bottom: 20px;
}

/* ============================================================
   最终 CTA
   ============================================================ */
.final-cta-section {
  padding: 20px 0 36px;
}

.final-cta-card {
  background: linear-gradient(145deg, #0F2347 0%, #1E3A5F 100%);
  border-radius: 18px;
  padding: 48px 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  box-shadow:
    0 16px 48px rgba(15,35,71,0.22),
    0 0 0 1px rgba(255,255,255,0.05) inset;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -10%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
}

.final-cta-text {
  flex: 1;
  min-width: 280px;
  position: relative;
  z-index: 1;

  h2 {
    font-family: $font-display;
    font-size: 1.8rem;
    font-weight: 800;
    color: #ffffff;
    margin: 0 0 14px;
    letter-spacing: -0.025em;
    line-height: 1.15;
  }

  p {
    font-size: 15px;
    line-height: 1.8;
    color: rgba(255,255,255,0.62);
    margin: 0;
  }
}

.final-cta-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  a {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: $accent;
    color: #0F2347;
    border: none;
    padding: 18px 40px;
    border-radius: 14px;
    font-family: $font-body;
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    box-shadow: 0 6px 28px rgba(245,158,11,0.35);

    &:hover {
      background: #D97706;
      transform: translateY(-3px) scale(1.03);
      box-shadow: 0 12px 40px rgba(245,158,11,0.45);
    }
  }
}

.final-meta {
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  font-weight: 500;
  letter-spacing: 0.03em;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1100px) {
  .hero-facts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 960px) {
  .hero-inner {
    max-width: 720px;
    padding: 0 8px;
  }

  .hero-title {
    max-width: 100%;
  }

  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .content-section {
    padding: 46px 0;
  }

  .download-info-grid,
  .risk-cards,
  .verdict-grid,
  .motivation-grid,
  .content-columns,
  .version-grid,
  .platform-list {
    grid-template-columns: 1fr;
  }

  .mods-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .troubleshoot-grid {
    grid-template-columns: 1fr;
  }

  .final-cta-card {
    padding: 36px 28px;
    flex-direction: column;
    text-align: center;
  }

  .final-cta-action {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .hero {
    padding: 28px 16px 36px;
    min-height: auto;
  }

  .hero-title { font-size: 1.85rem; }

  .hero-logo {
    width: 96px;
    height: 96px;
    border-radius: 22px;
  }

  .content-section {
    padding: 40px 0;
  }

  .section-inner {
    padding: 0 18px;
  }

  .section-tag {
    margin-bottom: 10px;
  }

  .section-title {
    font-size: 1.42rem;
    line-height: 1.22;
    margin-bottom: 18px;
  }

  .subsection-title {
    font-size: 1.05rem;
    margin-top: 24px;
  }

  .section-body p {
    font-size: 15px;
    line-height: 1.72;
    margin-bottom: 12px;
  }

  .feature-card,
  .troubleshoot-card,
  .motivation-card,
  .risk-card,
  .version-card,
  .platform-list article,
  .mod-item {
    padding: 18px;
  }

  .compare-table th,
  .compare-table td {
    padding: 11px 12px;
    font-size: 13px;
  }

  .install-timeline-item {
    grid-template-columns: 32px 1fr;
    gap: 12px;
    padding-bottom: 22px;
  }

  .install-timeline-item::before {
    left: 15px;
  }

  .install-timeline-dot {
    width: 32px;
    height: 32px;
  }

  .final-cta-card {
    padding: 32px 22px;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }

  .mods-grid {
    grid-template-columns: 1fr;
  }

  .hero-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .final-cta-text h2 { font-size: 1.5rem; }
}
</style>
